import { IParamsToSend } from '@base/@types/providers/Otb/PlanProvider'

export const planIndicatorsRequest: IParamsToSend = {
  periodo: {
    mes: 0,
    ano: 0,
    descricao: ''
  },
  empresasIds: [],
  mundosIds: [],
  categoriasCompactasIds: [],
  categoriasIds: []
}
